//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'my-areapicker',
    props: ['status', 'defaultValues'],
    data () {
        return {
            isShow: false,
            areaSlots: [
                {
                    flex: 1,
                    values: [],
                    defaultIndex: 0,
                    className: 'slot1',
                    textAlign: 'right'
                }, {
                    flex: 1,
                    values: [],
                    defaultIndex: 0,
                    className: 'slot3',
                    textAlign: 'center'
                }, {
                    flex: 1,
                    values: [],
                    defaultIndex: 0,
                    className: 'slot3',
                    textAlign: 'left'
                }
            ],
            changeLang: [],
            pid: 0,
            cid: 0,
            aid: 0,
            isLoading: false
        }
    },
    methods: {
        hideAreaPirker () {
            this.$emit('hide', false)
        },
        selAreaValue () {
            this.$emit('selValue', this.changeLang)
        },
        onAreaValuesChange (picker, values) {
            if (values[2] && values[2].id !== this.aid) {
                this.aid = values[2].id
                this.changeLang[2] = JSON.parse(JSON.stringify(values[2]))
            } else if (!this.isLoading && values[1] && values[1].id !== this.cid) {
                this.cid = values[1].id
                this.getAreaData({
                    pid: this.cid,
                    level: 3
                })
                this.changeLang[1] = JSON.parse(JSON.stringify(values[1]))
            } else if (!this.isLoading && values[0] && values[0].id !== this.pid) {
                this.pid = values[0].id
                console.log(values[0].id)
                this.getAreaData({
                    pid: this.pid || values[0].id,
                    level: 2
                })
                this.changeLang[0] = JSON.parse(JSON.stringify(values[0]))
            }
        },
        getAreaData (_params, callback) {
            console.log(JSON.stringify(_params))
            this.isLoading = true
            this.$http.get('/system/region/getRegion', {
                params: _params
            }).then(res => {
                this.isLoading = false
                if (res.data.status === 1 && res.data.code === 200) {
                    this.areaSlots[(_params.level || 1) - 1].values = res.data.data.regions
                    // if (typeof callback === 'function') {
                    //     callback(res.data.data.regions)
                    // }
                }
            }).catch(() => {
                this.isLoading = false
            })
        }
    },
    watch: {
        status (v) {
            this.isShow = v
            v && this.areaSlots[0].values.length < 1 && this.getAreaData({})
        }
    }
}
